import React from 'react';
import { Chip } from '@mui/material';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// "From the report": a value a lab report put into the Test form that has not been saved yet
// (TGCLOUD-1866, Phase 2 rework). Applying a report changes nothing on the server; saving the Test
// is what records it, so until then every applied value says where it came from. It goes when the
// clinician changes the value, and when the Test is saved.
export const FROM_REPORT_LABEL = 'from the report';

export default function FromReportMark({ sx }) {
  const t = useAutoTranslation();

  return (
    <Chip
      label={t(FROM_REPORT_LABEL)}
      size="small"
      variant="outlined"
      color="info"
      data-testid="from-report"
      sx={{ height: 18, fontSize: '0.68rem', ...sx }}
    />
  );
}
